import './ai-search-spinner.scss';

const DOT_COUNT = 3;

export const AIDotSpinner = () => {
  return (
    <div className="ai-search-spinner">
      <div className="dots-row">
        {Array.from({ length: DOT_COUNT }).map((_, i) => (
          <span
            key={i}
            className="dot"
            style={{ animationDelay: `${i * 0.05}s` }}
          />
        ))}
      </div>
    </div>
  );
};
